import { createFileRoute } from "@tanstack/react-router";

import { DiscoveryScreen } from "../features/discovery/DiscoveryScreen.tsx";

export const Route = createFileRoute("/_app/discovery/$id")({
  component: DiscoveryPage,
});

function DiscoveryPage() {
  const { id } = Route.useParams();
  return <DiscoveryScreen discoveryId={id} />;
}
